
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service/[slugOrId]",
      function () {
        return require("private-next-pages/service/[slugOrId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service/[slugOrId]"])
      });
    }
  